import {BaseModel} from '../common/base/base-model';
import {FiscalYear} from '../fiscalYear';

export class LawConservationConfigurationFiscalYear extends BaseModel {

  fiscalYear: FiscalYear;

}
